import ConfigNode from 'Model/ConfigNode'

class Macro extends ConfigNode

  @className: 'Macro'

  @load: (id) ->
    super(id, @)

  mapDbConfigToState: ->
    try
      data = JSON.parse(@get('configBlob'))
    catch
      data = @get('configBlob')
    {
      name: data.title
      steps: data.formSequence.sequence.map(({ fields }) -> fields)
      fieldData: _.mapValues(data.formSequence.formFields.reduce((acc, {
        formItem,
        formItemLabel,
        formItemType,
        formItemRules,
        formitemdefaultvalue,
        query,
        rest...
      }) ->
        {
          acc...,
          [formItem]: {
            key: formItem
            label: formItemLabel
            type: formItemType
            rules: formItemRules
            default: formitemdefaultvalue
            rest...
          }
        }
      , {}), (field) ->
        if queryKey = field?.derivedData?.querySource
          field.derivedData.query = data
            .formSequence
            .queries.find(({ id }) -> id is queryKey)
            ?.data?.query
        field
      )
      isHidden: data.hidden
      typeNode: data.formSequence.onSave?.node?.typeNode
      label: data.formSequence.onSave?.node?.typeLabel
      confirmationMessage: data.formSequence.onSave?.confirmation
      graph: data.formSequence.onSave?.node?.graph
    }

export default Macro
